import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { DollarSign } from "lucide-react";

export default function MaliyetView() {
  const [costs, setCosts] = useState(null);
  const [types, setTypes] = useState([]);

  useEffect(() => {
    api.get("/cost-index").then(({ data }) => setCosts(data)).catch(() => {});
    api.get("/insulation-types").then(({ data }) => setTypes(data)).catch(() => {});
  }, []);

  return (
    <section className="border-2 border-[#9D4EDD] bg-black" data-testid="maliyet-view">
      <header className="bg-[#9D4EDD] text-black px-4 py-3 flex items-center gap-2">
        <DollarSign className="w-5 h-5"/>
        <span className="font-mono text-sm uppercase tracking-[0.22em] font-extrabold">
          MALİYET · Cost Reference per Insulation Type
        </span>
      </header>

      {!costs ? (
        <div className="p-6 text-center font-mono text-sm font-bold text-white">Loading…</div>
      ) : (
        <div className="p-4 space-y-3">
          <div className="font-mono text-[11px] uppercase tracking-wider font-bold text-white compare-cyan">
            {costs.note} · Currency: <span className="text-[#9D4EDD]">{costs.currency}</span>
          </div>
          <div className="border-2 border-[#1F1F1F]">
            <div className="bg-[#0A0A0A] px-3 py-2 grid grid-cols-12 gap-2 font-mono text-[10px] uppercase tracking-wider font-extrabold">
              <div className="col-span-6 compare-cyan" data-testid="maliyet-hdr-material">Insulation Material</div>
              <div className="col-span-3 text-right compare-cyan" data-testid="maliyet-hdr-unit">€/m² · cm</div>
              <div className="col-span-3 text-right compare-cyan" data-testid="maliyet-hdr-5cm">5 cm · €/m²</div>
            </div>
            {costs.items.map((c) => {
              const t = types.find((x) => x.id === c.name_id);
              return (
                <div key={c.name_id}
                  className="grid grid-cols-12 gap-2 px-3 py-2 border-t border-[#1F1F1F] hover:bg-[#9D4EDD]/10 transition-colors"
                  data-testid={`maliyet-row-${c.name_id}`}>
                  <div className="col-span-6 text-white font-bold">{t ? t.name : c.name_id}</div>
                  <div className="col-span-3 text-right font-mono font-bold text-white">
                    € {c.cost_eur_per_m2_per_cm.toFixed(2)}
                  </div>
                  <div className="col-span-3 text-right font-mono font-extrabold text-[#9D4EDD]"
                    style={{ textShadow: "0 0 6px #9D4EDD88" }}>
                    € {(c.cost_eur_per_m2_per_cm * 5).toFixed(2)}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </section>
  );
}
